(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
const toggle=document.querySelector('.db-menu-toggle');const nav=document.querySelector('.db-nav');if(toggle&&nav){toggle.addEventListener('click',()=>{const open=nav.classList.toggle('open');toggle.setAttribute('aria-expanded',String(open))});nav.querySelectorAll('a').forEach(link=>link.addEventListener('click',()=>{nav.classList.remove('open');toggle.setAttribute('aria-expanded','false')}))}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('change', event => {
  const select = event.target.closest('[data-db-variant]');
  if (!select) return;
  const option = select.selectedOptions[0];
  const price = select.closest('.db-product-details').querySelector('.db-product-price');
  if (price && option) price.textContent = option.dataset.price;
  const image = select.closest('.db-product-layout').querySelector('.db-product-gallery img');
  if (image && option.dataset.image) { image.src = option.dataset.image; image.removeAttribute('srcset'); image.alt = option.dataset.imageAlt || ''; }
  const url = new URL(window.location.href);
  url.searchParams.set('variant', select.value);
  window.history.replaceState({}, '', url);
});

  } catch(e) { console.error(e); }
})();
})();
